module.exports = __webpack_public_path__ + "static/img/iconmonstr-phone-dial.47ddcd34.svg";